import type SinatraState from '../types/SinatraState';

export function selectMapProvider(state: { sinatra: SinatraState }) {
  return state.sinatra.ui?.mapProvider;
}
